import mitt from 'mitt';
import type { RouteLocationNormalized } from 'vue-router';

export interface RouteEventsPayload {
    from: RouteLocationNormalized;
    to: RouteLocationNormalized;
}

export const routeEvents = mitt<{
    'before-route-change': RouteEventsPayload;
}>();
